import axios from 'axios';
import { DEVICES_PATH } from '.';

export async function getSessionsByDeviceId(args) {
  const deviceId = Array.isArray(args) ? args[0].deviceId : args.deviceId 

  const response = await axios.get(`${DEVICES_PATH}/${deviceId}/sessions`);
  return response.data;
};